import http from './http'

// Public/Read-only
export function getScales(params) {
  return http.get('/scales/', { params })
}

export function getScale(id) {
  return http.get(`/scales/${id}/`)
}

// Admin/Manage Scales
export function getAdminScales(params) {
  return http.get('/scales/manage/scales/', { params })
}

export function createScale(data) {
  return http.post('/scales/manage/scales/', data)
}

export function updateScale(id, data) {
  return http.put(`/scales/manage/scales/${id}/`, data)
}

export function deleteScale(id) {
  return http.delete(`/scales/manage/scales/${id}/`)
}

export function importScale(file, params = {}) {
  const formData = new FormData()
  formData.append('file', file)
  if (params.overwrite) formData.append('overwrite', 'true')
  if (params.strategy) formData.append('strategy', params.strategy)
  if (params.new_title) formData.append('new_title', params.new_title)
  
  return http.post('/scales/manage/scales/import/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function exportScale(id) {
  return http.get(`/scales/manage/scales/${id}/export/`)
}

// Questions
export function getQuestions(params) {
  return http.get('/scales/manage/questions/', { params })
}

export function createQuestion(data) {
  return http.post('/scales/manage/questions/', data)
}

export function updateQuestion(id, data) {
  return http.put(`/scales/manage/questions/${id}/`, data)
}

export function patchQuestion(id, data) {
  return http.patch(`/scales/manage/questions/${id}/`, data)
}

export function deleteQuestion(id) {
  return http.delete(`/scales/manage/questions/${id}/`)
}

export function reorderQuestions(ids) {
  return http.post('/scales/manage/questions/reorder/', { ids })
}

// Options
export function getOptions(params) {
  return http.get('/scales/manage/options/', { params })
}

export function createOption(data) {
  return http.post('/scales/manage/options/', data)
}

export function updateOption(id, data) {
  return http.put(`/scales/manage/options/${id}/`, data)
}

export function deleteOption(id) {
  return http.delete(`/scales/manage/options/${id}/`)
}

// Dimensions
export function getDimensions(params) {
  return http.get('/scales/manage/dimensions/', { params })
}

export function createDimension(data) {
  return http.post('/scales/manage/dimensions/', data)
}

export function updateDimension(id, data) {
  return http.put(`/scales/manage/dimensions/${id}/`, data)
}

export function deleteDimension(id) {
  return http.delete(`/scales/manage/dimensions/${id}/`)
}

export function reorderDimensions(ids) {
  return http.post('/scales/manage/dimensions/reorder/', { ids })
}

// Interpretations
export function getInterpretations(params) {
  return http.get('/scales/manage/interpretations/', { params })
}

export function createInterpretation(data) {
  return http.post('/scales/manage/interpretations/', data)
}

export function updateInterpretation(id, data) {
  return http.put(`/scales/manage/interpretations/${id}/`, data)
}

export function deleteInterpretation(id) {
  return http.delete(`/scales/manage/interpretations/${id}/`)
}

// Norms
export function getNorms(params) {
  return http.get('/scales/manage/norms/', { params })
}

export function createNorm(data) {
  return http.post('/scales/manage/norms/', data)
}

export function updateNorm(id, data) {
  return http.put(`/scales/manage/norms/${id}/`, data)
}

export function deleteNorm(id) {
  return http.delete(`/scales/manage/norms/${id}/`)
}
